import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import InnerCollapsableCard from './priceOverrideRequestDetails/PriceOverrideRequestDetails';
import { convertTime24To12, setCurrencyFormat } from 'src/utils/util';
import { getDisplayDate, getTimeZoneName } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';
import {
    OuterLayout,
    Layout,
    AwaitingApproval,
    Pending,
    Account,
    InnerLayout,
    SummaryCard,
    SummaryHeading,
    SummaryContent,
    TissueServices,
    TissueNo,
    Title,
    Data,
    TissueServicesTotal,
    ApprovalContainer,
} from './PriceOverrideSummary.styled';
import { isMobileView } from 'src/utils/util';
import { priceFormatObj } from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PriceOverrideSummary = () => {
    const { t } = useTranslation();
    //collapsable card
    const [mainExpand, setMainExpand] = useState(false);
    const [subExpand, setSubExpand] = useState(true);
    const [priceOverrideSummaryUpdate, setPriceOverrideSummaryUpdate] =
        useState({});

    let priceOverrideSummary = useSelector(
        (state) =>
            state.orderSummaryReducer?.priceOverride?.priceOverrideSummary
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    useEffectWithErrorLogging(() => {
        if (priceOverrideSummary) {
            setPriceOverrideSummaryUpdate({
                ...priceOverrideSummary,
                orderDate: priceOverrideSummary?.orderDate
                    ? new Date(priceOverrideSummary.orderDate)
                    : null,
                requestedOn: priceOverrideSummary?.requestedOn
                    ? new Date(priceOverrideSummary.requestedOn)
                    : null,
            });
        }
    }, [priceOverrideSummary]);

    return (
        <CollapsableCard
            id="orders-priceOverrideSummary-priceOverrideSummary-summary"
            title={t('reportUsage.summary.title')}
            onClick={() => setMainExpand(!mainExpand)}
            isExpanded={mainExpand}
            padding={'1rem'}
            fontSizeMobile={'15px'}
            lineHeightMob={'27px'}
        >
            {mainExpand ? (
                <>
                    <InnerCollapsableCard
                    id="orders-priceoverride-summary-request-details-inner-card"
                        title={`Request Details - ${
                            priceOverrideSummaryUpdate?.orderType &&
                            orderBasicDetails?.currentOrderType === 'KE'
                                ? priceOverrideSummaryUpdate.orderType +
                                  ' Billing'
                                : priceOverrideSummaryUpdate?.orderType
                        }`}
                        onClick={() => setSubExpand(!subExpand)}
                        isExpanded={subExpand}
                        padding={'0rem'}
                    >
                        {subExpand ? (
                            <OuterLayout>
                                <Layout alignItems={'flex-start'}>
                                    <ApprovalContainer
                                        width={'70%'}
                                        mbWidth={'80%'}
                                    >
                                        <AwaitingApproval>
                                            {priceOverrideSummaryUpdate?.actionTypeMessage
                                                ? priceOverrideSummaryUpdate.actionTypeMessage
                                                : null}
                                        </AwaitingApproval>
                                    </ApprovalContainer>
                                    <ApprovalContainer
                                        width={'30%'}
                                        mbWidth={
                                            priceOverrideSummaryUpdate
                                                ?.approvalStatus.length > 8
                                                ? '50%'
                                                : '25%'
                                        }
                                    >
                                        <Pending>
                                            {' '}
                                            {priceOverrideSummaryUpdate?.approvalStatus
                                                ? priceOverrideSummaryUpdate.approvalStatus
                                                : null}{' '}
                                        </Pending>
                                    </ApprovalContainer>
                                </Layout>
                                <InnerLayout>
                                    {priceOverrideSummaryUpdate?.accountName ||
                                    priceOverrideSummaryUpdate?.accountId ? (
                                        <Account>
                                            <Title>
                                                {t(
                                                    'orders.orderListViewFilterDropDown.account'
                                                )}
                                            </Title>
                                            <Data>
                                                <span className="orders-account-dt-mask">{priceOverrideSummaryUpdate?.accountName
                                                    ? priceOverrideSummaryUpdate.accountName
                                                    : null}</span>
                                                <span className="orders-account-dt-mask"
                                                    style={{
                                                        fontFamily:
                                                            'AvenirNextWorld Italic',
                                                        margin: '0 0 0 3px',
                                                    }}
                                                >
                                                    {priceOverrideSummaryUpdate?.accountId
                                                        ? Number(
                                                              priceOverrideSummaryUpdate.accountId
                                                          ).toString()
                                                        : null}
                                                </span>
                                            </Data>
                                        </Account>
                                    ) : null}
                                    {priceOverrideSummaryUpdate?.myCaseRef ? (
                                        <Account>
                                            <Title>
                                                {t(
                                                    'orders.priceOverrideHistoryStatus.mycaseref'
                                                )}
                                            </Title>
                                            <Data>
                                                <span className="orders-price-override-my-case-ref-dt-mask">{
                                                    priceOverrideSummaryUpdate.myCaseRef
                                                }</span>
                                            </Data>
                                        </Account>
                                    ) : null}
                                </InnerLayout>
                                <InnerLayout>
                                    {priceOverrideSummaryUpdate?.overrideReason ||
                                    priceOverrideSummaryUpdate?.pricingNotes ? (
                                        <Account>
                                            <Title>
                                                {t(
                                                    'orders.priceOverrideHistoryStatus.reqreason'
                                                )}
                                            </Title>
                                            <Data>
                                                {
                                                    priceOverrideSummaryUpdate.overrideReason
                                                }
                                                <br />
                                                <span className="orders-note-text-dt-mask">{
                                                    priceOverrideSummaryUpdate?.pricingNotes
                                                }</span>
                                            </Data>
                                        </Account>
                                    ) : null}
                                    {priceOverrideSummaryUpdate?.requester ? (
                                        <Account>
                                            <Title>
                                                {t(
                                                    'orders.priceOverrideHistoryStatus.req'
                                                )}
                                            </Title>
                                            <Data>
                                                {
                                                    priceOverrideSummaryUpdate.requester
                                                }
                                            </Data>
                                        </Account>
                                    ) : null}
                                </InnerLayout>
                                <InnerLayout>
                                    {priceOverrideSummaryUpdate?.requestedOn ? (
                                        <Account>
                                            <Title>
                                                {t(
                                                    'orders.priceOverrideHistoryStatus.reqon'
                                                )}
                                            </Title>
                                            <Data>
                                                {getDisplayDate(
                                                    new Date(
                                                        priceOverrideSummaryUpdate.requestedOn
                                                    )
                                                )}
                                                <span
                                                    style={{ opacity: '0.3' }}
                                                >
                                                    {' | '}
                                                </span>
                                                {convertTime24To12(
                                                    new Date(
                                                        priceOverrideSummaryUpdate.requestedOn
                                                    )
                                                )}{' '}
                                                {getTimeZoneName()}
                                            </Data>
                                        </Account>
                                    ) : null}
                                    {orderBasicDetails?.currentOrderType !=
                                        'KE' &&
                                    priceOverrideSummaryUpdate?.orderDate ? (
                                        <Account>
                                            <Title>
                                                {t('common.surgeryDateLabel')}
                                            </Title>
                                            <Data>
                                                {getDisplayDate(
                                                    new Date(
                                                        priceOverrideSummaryUpdate.orderDate
                                                    )
                                                )}
                                            </Data>
                                            <div></div>
                                        </Account>
                                    ) : null}
                                </InnerLayout>
                            </OuterLayout>
                        ) : (
                            ''
                        )}
                    </InnerCollapsableCard>

                    {/* <SummaryCard margin={priceOverrideSummaryUpdate && '10px 0 0 0'}> */}
                    <SummaryCard marginTop="10px">
                        <SummaryHeading>
                            {t(
                                'orders.priceOverrideHistoryStatus.overridesummary'
                            )}
                        </SummaryHeading>

                        {countryISOCode === US_COUNTRY_CODE && (
                            <SummaryContent>
                                <TissueServices>
                                    {t('orders.orderTypes.tissueServices')}
                                </TissueServices>
                                <TissueNo>
                                    {setCurrencyFormat(
                                        priceOverrideSummaryUpdate.totalTissuePrice
                                    )}
                                </TissueNo>
                            </SummaryContent>
                        )}

                        <SummaryContent>
                            <TissueServices>
                                {countryISOCode === US_COUNTRY_CODE
                                    ? t('orders.orderTypes.nonTissue')
                                    : t('consignment.itemList.items')}
                            </TissueServices>
                            <TissueNo>
                                {setCurrencyFormat(
                                    priceOverrideSummaryUpdate.totalNonTissuePrice
                                )}
                            </TissueNo>
                        </SummaryContent>

                        <SummaryContent>
                            <TissueServices color={'#E5047E'}>
                                {`${t(
                                    'equity.priceOverride.summaryConainer.variance'
                                )} (${
                                    priceOverrideSummaryUpdate.varianceAmount >
                                    0
                                        ? `-${parseFloat(
                                              Math.abs(
                                                  priceOverrideSummaryUpdate.discountPercent
                                              )
                                          ).toFixed(2)}`
                                        : priceOverrideSummaryUpdate.varianceAmount ===
                                          0
                                        ? `${parseFloat(
                                              Math.abs(
                                                  priceOverrideSummaryUpdate.discountPercent
                                              )
                                          ).toFixed(2)}`
                                        : `+${parseFloat(
                                              Math.abs(
                                                  priceOverrideSummaryUpdate.discountPercent
                                              )
                                          ).toFixed(2)}`
                                } %)`}
                            </TissueServices>
                            <TissueNo color={'#E5047E'}>
                                {`${
                                    priceOverrideSummaryUpdate.varianceAmount >
                                    0
                                        ? `-${setCurrencyFormat(
                                              priceOverrideSummaryUpdate.varianceAmount
                                          )}`
                                        : priceOverrideSummaryUpdate.varianceAmount ===
                                          0
                                        ? `${setCurrencyFormat(
                                              priceOverrideSummaryUpdate.varianceAmount
                                          )}`
                                        : `+${setCurrencyFormat(
                                              priceOverrideSummaryUpdate.varianceAmount
                                          )}`
                                }`}
                            </TissueNo>
                        </SummaryContent>

                        <SummaryContent>
                            <TissueServices>
                                <TissueServicesTotal>
                                    {t(
                                        'equity.priceOverride.summaryConainer.total'
                                    )}
                                </TissueServicesTotal>
                            </TissueServices>
                            <TissueNo>
                                <TissueServicesTotal>
                                    {setCurrencyFormat(
                                        priceOverrideSummaryUpdate.discountedTotalPrice
                                    )}
                                </TissueServicesTotal>
                            </TissueNo>
                        </SummaryContent>

                        <SummaryContent
                            textAlign={isMobileView() ? 'right' : 'left'}
                        >
                            <TissueServices
                                fontSize={'12px'}
                                color="#202124"
                                float="none"
                            >
                                {t(
                                    'orders.orderDetails.priceOverride.priceOverrideSummary.doesNotIncludeMsg'
                                )}
                            </TissueServices>
                        </SummaryContent>
                    </SummaryCard>
                    {priceOverrideSummaryUpdate?.gpo ||
                    priceOverrideSummaryUpdate?.gpo ||
                    priceOverrideSummaryUpdate?.idn ||
                    priceOverrideSummaryUpdate?.sapOrderId ? (
                        <SummaryCard>
                            <InnerLayout>
                                {priceOverrideSummaryUpdate?.peNo ? (
                                    <Account padding="0rem 0rem 0.5rem 0rem">
                                        <Title>
                                            {t(
                                                'orders.orderDetails.priceOverride.priceOverrideSummary.pe'
                                            )}
                                        </Title>
                                        <Data>
                                            <span>
                                                {
                                                    priceOverrideSummaryUpdate.peNo
                                                }
                                            </span>
                                        </Data>
                                    </Account>
                                ) : null}
                                {priceOverrideSummaryUpdate?.gpo ? (
                                    <Account padding="0rem 0rem 0.5rem 0rem">
                                        <Title>
                                            {t(
                                                'orders.orderDetails.priceOverride.priceOverrideSummary.gpo'
                                            )}
                                        </Title>
                                        <Data>
                                            {priceOverrideSummaryUpdate.gpo}
                                        </Data>
                                    </Account>
                                ) : null}
                            </InnerLayout>
                            <InnerLayout>
                                {priceOverrideSummaryUpdate?.idn ? (
                                    <Account padding="0rem 0rem 0.5rem 0rem">
                                        <Title>
                                            {t(
                                                'orders.orderDetails.priceOverride.priceOverrideSummary.idn'
                                            )}
                                        </Title>
                                        <Data>
                                            {priceOverrideSummaryUpdate.idn}
                                        </Data>
                                    </Account>
                                ) : null}

                                {priceOverrideSummaryUpdate?.sapOrderId ? (
                                    <Account padding="0rem 0rem 0.5rem 0rem">
                                        <Title>
                                            {t(
                                                'orders.orderDetails.priceOverride.priceOverrideSummary.saporder'
                                            )}
                                        </Title>
                                        <Data>
                                            {
                                                priceOverrideSummaryUpdate.sapOrderId
                                            }
                                        </Data>
                                    </Account>
                                ) : null}
                            </InnerLayout>
                        </SummaryCard>
                    ) : null}
                </>
            ) : null}
        </CollapsableCard>
    );
};

export default PriceOverrideSummary;
